import GTM from '@activebrands/core-web/libs/Tracking/GTM';

export default () => GTM.reset();
